import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import Login from '@/pages/home/Home-page.vue';
import Users from '@/pages/users/Users-page.vue';
import UserInfoPage from '@/pages/userInfo/User-info-page.vue';
import pageUrls from '@/router/pageUrls';
import ZipCodesPage from '@/pages/zipCodes/Zip-codes-page.vue';
import DigitizeProductPage from '@/pages/digitize/Digitize-product-page.vue';
import RushesPage from '@/pages/rushes/Rushes-page.vue';
import GiftCardPage from '@/pages/giftCard/Gift-card-page.vue';
import PermissionsPage from '@/pages/permissions/Permissions-page.vue';
import CreatePage from '@/pages/create/Create-page.vue';
import DeliveriesPage from '@/pages/deliveries/Deliveries-page.vue';
import HelpCenterPage from '@/pages/helpCenter/Help-center-page.vue';
import CollectionsPage from '@/pages/collections/Collections-page.vue';
import BlogsPage from '@/pages/blogs/Blogs-page.vue';
import ArticlePage from '@/pages/article/Article-page.vue';
import PromotionsPage from '@/pages/promotions/Promotions-page.vue';
import EnhanceProductPage from '@/pages/enhance/Enhance-product-page.vue';
import SettingsPage from '@/pages/settings/Settings-page.vue';
import PagesContent from '@/pages/pagesContent/Pages-Content.vue';
import CompaniesPage from '@/pages/companies/Companies-page.vue';
import CompanyPage from '@/pages/companies/Company-page.vue';
import PageContentPage from '@/pages/companies/company-tabs/PageContent-page.vue';
import ProductCollectionsPage from '@/pages/companies/company-tabs/ProductCollections-page.vue';
import PhotoGalleriesPage from '@/pages/companies/company-tabs/PhotoGalleries-page.vue';
import OrdersPage from '@/pages/companies/company-tabs/Orders-page.vue';
import ReportsPage from '@/pages/companies/company-tabs/Reports-page.vue';
import CompanyUsersPage from '@/pages/companies/company-tabs/Users-page.vue';
import CompanyDeliveriesPage from '@/pages/companies/company-tabs/Deliveries-page.vue';
import ProcessingPage from '@/pages/companies/company-tabs/Processing-page.vue';
import CompanyHelpCenterPage from '@/pages/companies/company-tabs/HelpCenter-page.vue';
import AlbumsPage from '@/pages/albums/Albums-page.vue';
import ErrorLogsPage from '@/pages/errorLogs/Error-logs-page.vue';
import AnalyticsDashboardPage from '@/pages/analytics/Analytics-dashboard-page.vue';
import SessionsListPage from '@/pages/analytics/Sessions-list-page.vue';
import SessionPlayerPage from '@/pages/analytics/Session-player-page.vue';
import HeatmapsPage from '@/pages/analytics/Heatmaps-page.vue';
import FrontendErrorsPage from '@/pages/analytics/Frontend-errors-page.vue';
import AlertsPage from '@/pages/analytics/Alerts-page.vue';
import AnalyticsApiKeysPage from '@/pages/analytics/Analytics-api-keys-page.vue';

const {
  loginPage,
  usersPage,
  zipCodesPage,
  digitizePage,
  rushesPage,
  giftCardPage,
  permissionsPage,
  createPage,
  deliveriesPage,
  helpCenterPage,
  blogsPage,
  articleEditorPage,
  collectionsPage,
  promotionsPage,
  enhancePage,
  settingsPage,
  pagesContent,
  companiesPage,
  albumsPage,
  errorLogsPage,
  analyticsDashboard,
  sessionsList,
  heatmapsPage,
  frontendErrorsPage,
  alertsPage,
  analyticsApiKeysPage,
} = pageUrls;

const routes = [
  {
    path: loginPage,
    component: Login,
  },
  {
    path: usersPage,
    component: Users,
  },
  {
    path: `${usersPage}/:id`,
    component: UserInfoPage,
  },
  {
    path: zipCodesPage,
    component: ZipCodesPage,
  },
  {
    path: `${digitizePage}/:type`,
    component: DigitizeProductPage,
  },
  {
    path: `${createPage}`,
    component: CreatePage,
  },
  {
    path: promotionsPage,
    component: PromotionsPage,
  },
  {
    path: rushesPage,
    component: RushesPage,
  },
  {
    path: `${giftCardPage}/:type`,
    component: GiftCardPage,
  },
  {
    path: helpCenterPage,
    component: HelpCenterPage,
  },
  {
    path: permissionsPage,
    component: PermissionsPage,
  },
  {
    path: deliveriesPage,
    component: DeliveriesPage,
  },
  {
    path: collectionsPage,
    component: CollectionsPage,
  },
  {
    path: `${blogsPage}/:type`,
    component: BlogsPage,
  },
  {
    path: `${articleEditorPage}/:id`,
    component: ArticlePage,
  },
  {
    path: articleEditorPage,
    component: ArticlePage,
  },
  {
    path: `${enhancePage}/:type`,
    component: EnhanceProductPage,
  },
  {
    path: `${settingsPage}/:tab`,
    component: SettingsPage,
  },
  {
    path: pagesContent,
    component: PagesContent,
  },
  {
    path: albumsPage,
    component: AlbumsPage,
  },
  {
    path: companiesPage,
    component: CompaniesPage,
  },
  {
    path: `${companiesPage}/:id`,
    component: CompanyPage,
  },
  {
    path: `${companiesPage}/:id/page-content`,
    component: PageContentPage,
  },
  {
    path: `${companiesPage}/:id/product-collections`,
    component: ProductCollectionsPage,
  },
  {
    path: `${companiesPage}/:id/photo-galleries`,
    component: PhotoGalleriesPage,
  },
  {
    path: `${companiesPage}/:id/orders`,
    component: OrdersPage,
  },
  {
    path: `${companiesPage}/:id/reports`,
    component: ReportsPage,
  },
  {
    path: `${companiesPage}/:id/users`,
    component: CompanyUsersPage,
  },
  {
    path: `${companiesPage}/:id/deliveries`,
    component: CompanyDeliveriesPage,
  },
  {
    path: `${companiesPage}/:id/processing`,
    component: ProcessingPage,
  },
  {
    path: `${companiesPage}/:id/help-center`,
    component: CompanyHelpCenterPage,
  },
  {
    path: `${companiesPage}/:id/api-config`,
    component: () => import('@/pages/companies/api-config/CompanyApiConfig-page.vue'),
  },
  {
    path: `${companiesPage}/:id/page-builder`,
    component: () => import('@/pages/companies/company-tabs/PageBuilder-page.vue'),
  },
  {
    path: `${companiesPage}/:id/page-builder/form-submissions`,
    component: () => import('@/pages/companies/company-tabs/FormSubmissions-page.vue'),
  },
  {
    path: `${companiesPage}/:id/page-builder/analytics`,
    component: () => import('@/pages/companies/company-tabs/PageAnalytics-page.vue'),
  },
  {
    path: `${companiesPage}/:id/page-builder/:pageId`,
    component: () => import('@/pages/companies/company-tabs/PageBuilderEditor-page.vue'),
  },
  {
    path: errorLogsPage,
    component: ErrorLogsPage,
    meta: { requiresAdmin: true },
  },
  // Analytics routes
  {
    path: analyticsDashboard,
    component: AnalyticsDashboardPage,
    meta: { requiresAdmin: true },
  },
  {
    path: sessionsList,
    component: SessionsListPage,
    meta: { requiresAdmin: true },
  },
  {
    path: `${sessionsList}/:id`,
    component: SessionPlayerPage,
    meta: { requiresAdmin: true },
  },
  {
    path: heatmapsPage,
    component: HeatmapsPage,
    meta: { requiresAdmin: true },
  },
  {
    path: frontendErrorsPage,
    component: FrontendErrorsPage,
    meta: { requiresAdmin: true },
  },
  {
    path: alertsPage,
    component: AlertsPage,
    meta: { requiresAdmin: true },
  },
  {
    path: analyticsApiKeysPage,
    component: AnalyticsApiKeysPage,
    meta: { requiresAdmin: true },
  },
];

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
});

router.beforeEach((to, from, next) => {
  const token = store.state.auth.idToken;

  // Not authenticated — redirect to login (except login page itself)
  if (!token && to.path !== '/') {
    next('/');
    return;
  }

  // Company users are restricted to their own company page only
  const isCompanyUser = store.getters['auth/isCompanyUser'];
  if (isCompanyUser) {
    const companyId = store.state.auth.company?.id;
    const allowedPrefix = `/pod/${companyId}`;

    if (to.path !== '/' && !to.path.startsWith(allowedPrefix)) {
      next(allowedPrefix);
      return;
    }
  }

  // Check admin-only pages
  if (to.meta.requiresAdmin) {
    const userRole = store.state.auth.role;
    const isAdmin = userRole === 'admin' || userRole === 'Admin' || store.state.auth.id === 1;
    if (!isAdmin) {
      next(usersPage);
      return;
    }
  }

  next();
});

export default router;
